export default __webpack_public_path__ + "static/media/mcclogo.554f3882.png";